var _excluded = ["type"],
  _excluded2 = ["suburb", "status", "propertytypes", "beds"],
  _excluded3 = ["suburb", "status", "district", "region"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import merge from 'lodash/merge';
import queryString from 'qs';
import { ListingSortOrder, ListingType, LocalityType, PropertyType, LocalityTypeName } from '@domain-group/fe-allhomes-library/lib/node';
import defaults from '../enums/defaults';
import ResultType from '../enums/result-type';
import { values as objectValues, propertiesOf, isA } from '../utils';
import QbnInCbrSpecialFilter from './special-filters/qbn-in-cbr-special-filter';
import Filters from './filters';
import { parseListingType } from '../utils/parse-listing-type';
var forward = (target, source, methods) => {
  methods.forEach(method => {
    target[method] = function () {
      return target[source][method](...arguments);
    }; // eslint-disable-line no-param-reassign
  });
};
var sortToUrl = sort => {
  var value = sort && "".concat(sort.criteria).concat(sort.order && "-".concat(sort.order)).toLowerCase();
  return (objectValues(ListingSortOrder).find(each => each.value === value) || {
    urlSlug: value
  }).urlSlug;
};
var parseResults = function parseResults() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    type: type ? type.toUpperCase() : defaults.RESULT_TYPE
  }, rest);
};
var parseSort = (sort, listingType) => {
  if (!sort) {
    return null;
  }
  var order;
  var criteria;
  var options;
  if (typeof sort === 'string') {
    var parts = sort.split('-');
    var _parts = _slicedToArray(parts, 2);
    criteria = _parts[0];
    order = _parts[1];
  } else {
    criteria = sort.criteria;
    order = sort.order;
    options = sort.options;
  }
  return {
    criteria: isEmpty(criteria) ? defaults.SORT_FIELD(listingType) : criteria.toUpperCase(),
    order: isEmpty(order) ? defaults.SORT_ORDER : order.toUpperCase(),
    options
  };
};
var parseSortFromSlug = (slug, listingType) => parseSort((objectValues(ListingSortOrder).find(each => each.urlSlug === slug) || {}).value, listingType);
var generateSearchQueryClass = function generateSearchQueryClass() {
  var FiltersClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Filters;
  class SearchQuery {
    constructor(listingType) {
      var values = SearchQuery.valuesOf(arguments.length <= 1 ? undefined : arguments[1]);
      var _ref2 = values && values.filters ? values : _objectSpread({
          filters: arguments.length <= 1 ? undefined : arguments[1]
        }, arguments.length <= 2 ? undefined : arguments[2]),
        filters = _ref2.filters,
        sort = _ref2.sort,
        page = _ref2.page,
        pageSize = _ref2.pageSize,
        results = _ref2.results;
      this.sort = parseSort(sort, listingType);
      this.page = page;
      this.pageSize = pageSize == null ? defaults.PAGE_SIZE : pageSize;
      this.filters = new FiltersClass(listingType, filters);
      this.results = parseResults(results);
      this.applyDefaults();
      forward(this, 'filters', ['getLocalities', 'getSingleLocality', 'resolveLocalities', 'getBounds', 'isSold', 'isRented']);
    }
    toQueryObject() {
      var filters = this.filters.toQueryObject();
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.page && {
        page: this.page
      }), this.pageSize == null || {
        pageSize: this.pageSize
      }), !isEmpty(this.sort) && {
        sort: this.sort
      }), !isEmpty(filters) && {
        filters
      }), this.results && {
        results: this.results
      });
    }
    get listingType() {
      return this.filters.listingType;
    }
    isMapSearch() {
      return get(this, 'results.type', '') === ResultType.MAP;
    }
    isListSearch() {
      return get(this, 'results.type', '') === ResultType.LIST;
    }
    isDefault() {
      return this.filters.isDefault();
    }
    getMapLevel() {
      return this.isMapSearch() ? this.map.level : undefined;
    }

    /** indicates whether or not the search is considered to be "broad".
     * At the moment, that means any search containing only district, regions or postcodes
     */
    isBroadSearch() {
      var moreSpecificLocality = this.filters.getLocalities().find(locality => ![LocalityTypeName.DISTRICT, LocalityTypeName.REGION, LocalityTypeName.POSTCODE].includes(locality.type));
      return this.filters.isLocationEmpty() || !moreSpecificLocality;
    }
    getSortUrl() {
      return sortToUrl(this.sort);
    }
    toUrlParameters() {
      var sort = sortToUrl(this.sort);
      var defaultSortString = sortToUrl({
        criteria: defaults.SORT_FIELD(this.listingType),
        order: defaults.SORT_ORDER
      });
      return [sort && sort !== defaultSortString && {
        sort
      }, this.page && this.page !== defaults.PAGE && {
        page: "".concat(this.page)
      }, this.isMapSearch() && {
        view: ResultType.MAP.toLowerCase()
      }, ...this.filters.toUrlParameters()].filter(each => each);
    }
    getValues() {
      return _objectSpread(_objectSpread({}, propertiesOf(this)), {}, {
        filters: this.filters.getValues()
      });
    }
    applyDefaults() {
      if (!this.page) {
        this.page = defaults.PAGE;
      }
      this.sort = merge({}, this.sort, !get(this, 'sort.criteria') && {
        criteria: defaults.SORT_FIELD(this.listingType)
      }, !get(this, 'sort.order') && {
        order: defaults.SORT_ORDER
      });
      return this;
    }
    isSearchQuery() {
      return true;
    }

    // Simplest definition of an indexable Query is one that has no query parameters except for "page"
    isIndexable() {
      var url = this.toSearchUrl();

      // eslint-disable-next-line no-unused-vars
      var _url$split = url.split('?'),
        _url$split2 = _slicedToArray(_url$split, 2),
        _urlBase = _url$split2[0],
        searchParams = _url$split2[1];

      // Test whether there are any search parameters other than "page"
      return !(searchParams || '').split('&').filter(each => each.length > 0).map(each => each.split('=')[0]).some(each => each.toLowerCase() !== 'page');
    }
    toSearchUrl() {
      var _this$filters$beds, _this$filters$propert;
      var isResiSold = this.isSold() && this.listingType === ListingType.SALES_RESIDENTIAL.name;
      var _this$toUrlParameters = this.toUrlParameters().reduce((obj, param) => _objectSpread(_objectSpread({}, obj), param), {}),
        suburb = _this$toUrlParameters.suburb,
        status = _this$toUrlParameters.status,
        propertytypes = _this$toUrlParameters.propertytypes,
        beds = _this$toUrlParameters.beds,
        otherParams = _objectWithoutProperties(_this$toUrlParameters, _excluded2);
      var singleLocality = this.getSingleLocality();
      var useSingleLocality = singleLocality && singleLocality.slug && singleLocality.type === LocalityType.DIVISION.type;
      var singleBeds = useSingleLocality && ((_this$filters$beds = this.filters.beds) === null || _this$filters$beds === void 0 ? void 0 : _this$filters$beds.getSingleValue());
      var singlePropertyType = useSingleLocality && ((_this$filters$propert = this.filters.propertyTypes) === null || _this$filters$propert === void 0 ? void 0 : _this$filters$propert.getSingleValue());
      var params = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !useSingleLocality && suburb && {
        suburb
      }), !isResiSold && status && {
        status
      }), otherParams), !singlePropertyType && propertytypes && {
        propertytypes
      }), !singleBeds && beds && {
        beds
      });
      var queryParam = isEmpty(params) ? '' : "?".concat(queryString.stringify(params, {
        encode: false
      }));
      var searchType = isResiSold ? 'sold' : ListingType[this.filters.listingType].urlContext;
      var urlParts = [searchType, useSingleLocality ? singleLocality.slug : 'search', ...(singlePropertyType ? [PropertyType[singlePropertyType].urlSlug] : []), ...(singleBeds ? ["".concat(singleBeds, "-bedrooms")] : [])];
      var baseUrl = urlParts.join('/');
      return "/".concat(baseUrl).concat(useSingleLocality ? '/' : '').concat(queryParam);
    }
    toNewListingsUrl() {
      var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'new-listings';
      var searchType = ListingType[this.filters.listingType].urlContext;
      var singleLocality = this.getSingleLocality();
      if (!singleLocality) {
        throw new Error("New Listings/Price URL only works for single localities, localities were: ".concat(JSON.stringify(this.filters.localities)));
      }
      var _this$toUrlParameters2 = this.toUrlParameters().reduce((obj, param) => _objectSpread(_objectSpread({}, obj), param), {}),
        suburb = _this$toUrlParameters2.suburb,
        status = _this$toUrlParameters2.status,
        district = _this$toUrlParameters2.district,
        region = _this$toUrlParameters2.region,
        params = _objectWithoutProperties(_this$toUrlParameters2, _excluded3);
      var baseUrl = "/".concat(searchType, "/").concat(this.getSingleLocality().slug);
      var queryParam = isEmpty(params) ? '' : "?".concat(queryString.stringify(params, {
        encode: false
      }));
      return "".concat(baseUrl, "/").concat(pageType, "/").concat(queryParam);
    }
    cloneWith() {
      var newValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var filters = newValues.filters,
        queryValues = newValues.queryValues;
      var updatedObject = _objectSpread(_objectSpread(_objectSpread({}, this.getValues()), queryValues), {}, {
        filters: this.filters.cloneWith(filters).getValues()
      });
      return new SearchQuery(this.listingType, updatedObject);
    }
    cloneWithLocalities(localities) {
      return this.cloneWith({
        filters: {
          localities
        }
      });
    }
  }
  SearchQuery.isInstance = value => isA(value, 'SearchQuery');
  SearchQuery.valuesOf = obj => SearchQuery.isInstance(obj) ? obj.getValues() : obj;
  SearchQuery.toQueryObject = queryOrObject => SearchQuery.isInstance(queryOrObject) ? queryOrObject.toQueryObject() : queryOrObject;
  SearchQuery.fromPossibleQueryObject = (listingType, queryOrObject) => SearchQuery.isInstance(queryOrObject) ? queryOrObject : SearchQuery.fromQueryObject(listingType, queryOrObject);
  SearchQuery.fromQueryObject = (listingType, body) => new SearchQuery(listingType, FiltersClass.fromQueryObject(listingType, body), {
    sort: body.sort,
    pageSize: body.pageSize,
    page: parseInt(body.page, 10) || null,
    results: body.results
  });

  /**
   * Construct a SearchQuery from URL parameters.
   * Also accepts `listingType, queryParameters, pathParameters` to support legacy usags.
   * @param pathParameters
   * @param queryParameters
   * @returns a new SearchQuery object
   */
  SearchQuery.fromUrlParameters = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _ref3 = typeof args[0] === 'string' ? args : [parseListingType(args[0].listingType), args[1], args[0]],
      _ref4 = _slicedToArray(_ref3, 3),
      listingType = _ref4[0],
      _ref4$ = _ref4[1],
      queryParameters = _ref4$ === void 0 ? {} : _ref4$,
      _ref4$2 = _ref4[2],
      pathParameters = _ref4$2 === void 0 ? {} : _ref4$2;
    return new SearchQuery(listingType, FiltersClass.fromUrlParameters(listingType, queryParameters, pathParameters), {
      sort: parseSortFromSlug(queryParameters.sort, listingType),
      page: parseInt(queryParameters.page, 10) || null,
      results: {
        type: isEqual(toLower(queryParameters.view), toLower(ResultType.MAP)) ? ResultType.MAP : ResultType.LIST
      },
      divisionId: get(pathParameters, 'divisionId')
    });
  };
  return SearchQuery;
};
var SearchQuery = generateSearchQueryClass();
var NewListingsSearchQuery = generateSearchQueryClass(QbnInCbrSpecialFilter);
export default SearchQuery;
export { generateSearchQueryClass, NewListingsSearchQuery };